import { AppStyle } from 'decorators/withStyles';
import { fontSizePxToRem, setMargin } from 'helpers/functions';

const styles: AppStyle = theme => ({
  rootPaper: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    backgroundColor: 'white',
    boxShadow: 'none !important',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      zIndex: 1100,
    },
    zIndex: 1100,
  },
  color: {
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  menuButton: {
    ...setMargin(null, 20, null, null),
    color: '#000000',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  alignButtonsDesktop: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  notificationItem: {
    height: 65,
    padding: 24,
    display: 'flow-root',
    '&:not(:last-child)': {
      borderBottom: '1px solid #d9d9d9',
    },
  },
  avatarDesktop: {
    height: 24,
    width: 24,
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.primary.contrastText}`,
    ...setMargin(0, 5, 0, 0),
  },
  paper: {
    top: 50,
    minHeight: 200,
    width: 400,
  },
  linkStyle: {
    textDecoration: 'none',
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'flex',
    alignItems: 'center',
  },
  logoDesktop: {
    maxWidth: '25%',
    maxHeight: 35,
    position: 'absolute',
    left: '2%',
  },
  logoMobile: {
    margin: '0 auto',
    width: '30%',
  },
  menuMobile: {
    color: '#000000',
  },
  iconStyle: {
    fontSize: fontSizePxToRem(16),
    ...setMargin(null, 4, null, null),
  },
  headerDesktop: {
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-end',
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  headerOption: {
    color: '#000000',
    ...setMargin(0, 15, 0, 15),
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
  },
  noAvatarIcon: {
    color: theme.palette.primary.contrastText,
    marginRight: 5,
  },
  avatarMobile: {
    width: 22,
    height: 22,
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.primary.contrastText}`,
  },
  headerMobile: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

export default styles;
